import {event} from '../modules/event';

class Title {
    constructor(btn) {
        this._createElements(btn);
        this._addEvents();
    }

    _createElements(btn){
        this.btn = btn;
        this.inner = this.btn.getAttribute('title');
        this.btn.removeAttribute('title');
    }

    _addEvents(){
        var self = this;
        event.add(this.btn, 'mouseenter',  function(){self._show.call(self)});
    }

    _show(){
        var self = this,
            box = document.createElement('DIV');

        event.add(this.btn, 'mouseleave',  function onOut(){self._hide.call(self, box, onOut)});

        box.className = 'title_popup';
        box.innerHTML = this.inner;
        this.btn.appendChild(box);
    }

    _hide(box, onOut){
        event.remove(this.btn, 'mouseleave',  onOut);
        this.btn.removeChild(box);
    }
}

export {Title};




































